"use client"

import { Textarea } from "@/components/ui/textarea"
import { FormItem, FormLabel, FormDescription, FormMessage, FormField } from "@/components/ui/form"
import type { FormElement } from "./types"
import type { UseFormReturn } from "react-hook-form"

interface FormTextareaProps {
  element: FormElement
  form: UseFormReturn<any>
}

export function FormTextarea({ element, form }: FormTextareaProps) {
  return (
    <FormField
      control={form.control}
      name={element.name!}
      rules={{
        required: element.validation?.required ? `${element.ui?.label || element.name} is required` : false,
        minLength: element.validation?.minLength
          ? { value: element.validation.minLength, message: `Minimum length is ${element.validation.minLength}` }
          : undefined,
        maxLength: element.validation?.maxLength
          ? { value: element.validation.maxLength, message: `Maximum length is ${element.validation.maxLength}` }
          : undefined,
      }}
      render={({ field }) => (
        <FormItem>
          {element.ui?.label && <FormLabel htmlFor={`form-${element.name}`}>{element.ui.label}</FormLabel>}
          <Textarea
            id={`form-${element.name}`}
            placeholder={element.ui?.placeholder}
            rows={element.attributes?.rows}
            name={field.name}
            value={field.value || ""}
            onChange={field.onChange}
            onBlur={field.onBlur}
            ref={field.ref}
          />
          {element.ui?.hint && <FormDescription>{element.ui.hint}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  )
}

